module.exports = __webpack_public_path__ + "img/s-hd.ccbfb9a8.jpg";